/* src/app/modules/finanzas/efectivo/efectivo-dialog.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.ef-header-text {
  min-width: 0;
  padding-right: 32px;
}
.ef-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.ef-body {
  padding: 0 !important;
}
.ef-suffix {
  font-size: 14px;
  color: #6b7280;
  margin-right: 6px;
}
.ef-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  color: #6b7280;
  cursor: pointer;
}
.ef-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.ef-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
.ef-uid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
}
.ef-uid__value {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
  font-size: 12px;
  color: #6b7280;
  overflow-wrap: anywhere;
}
.ef-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 24px;
  background:
    linear-gradient(
      135deg,
      #fbfee8 0%,
      #f4fbd0 100%);
  border-bottom: 1px solid #e5f3a0;
}
.ef-summary__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.ef-summary__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .45);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ef-summary__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #1a1d23;
}
.ef-summary__label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #6b7280;
}
.ef-summary__amount {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #1a1d23;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.ef-summary__hint {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}
.ef-section {
  padding: 18px 24px 6px;
  border-bottom: 1px solid #f0f0f0;
}
.ef-section:last-child {
  border-bottom: none;
  padding-bottom: 18px;
}
.ef-section .cf-dlg-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.ef-section .cf-dlg-mismatch {
  margin-bottom: 12px;
}
.ef-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0 16px;
}
.ef-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.ef-empty mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.ef-empty--error mat-icon {
  color: #dc2626;
}
.ef-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.ef-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  min-width: 0;
}
.ef-row--editing {
  border-color: #c5d94a;
  background: #fbfee8;
}
.ef-row__main {
  flex: 1;
  min-width: 0;
}
.ef-row__concept {
  font-size: 14px;
  font-weight: 600;
  color: #1a1d23;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ef-row__meta {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ef-row__amount {
  text-align: right;
  flex-shrink: 0;
}
.ef-row__amount strong {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ef-row__amount span {
  display: block;
  font-size: 11px;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ef-row__actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.ef-row__btn {
  width: 32px !important;
  height: 32px !important;
  padding: 4px !important;
  color: #6b7280 !important;
}
.ef-row__btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ef-row__btn--danger:hover {
  color: #dc2626 !important;
}
@media (max-width: 600px) {
  .ef-summary {
    padding: 12px 16px;
  }
  .ef-section {
    padding: 14px 16px 4px;
  }
  .ef-row {
    flex-wrap: wrap;
  }
  .ef-row__main {
    flex-basis: 100%;
  }
  .ef-row__amount {
    text-align: left;
    flex: 1;
  }
}
/*# sourceMappingURL=efectivo-dialog.component.css.map */
